import { Container, Text, Flex, Image, get, Box } from "theme-ui";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

import { HomeBanner, Principles } from "src/components";
import logo from "src/assets/images/logo_color.png";
import { viewVariants } from "src/utils";
import { extractBaseLang } from "src/utils";

export const Home = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = extractBaseLang(i18n.language);
  return (
    <motion.div
      variants={viewVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <Container
        sx={{
          p: [4, 4, 7],
          maxWidth: (theme) => get(theme, "breakpoints.2"),
        }}
      >
        <HomeBanner />
        <Box sx={{ mt: [7, 7, 8], mb: [5, 5, 7] }}>
          <Principles />
        </Box>
        <Flex sx={{ flexDirection: "column", alignItems: "center" }}>
          <Text
            as="h3"
            sx={{
              fontWeight: 500,
              fontSize: [2, 2, 3],
              textAlign: "center",
              whiteSpace: "pre-wrap",
              px: 3,
            }}
          >
            {t("home.subText")}
          </Text>
          <Image
            src={logo}
            alt="vecinos"
            sx={{
              mt: 6,
              mb: 5,
              width: ["6.25rem", "8.75rem"],
              height: ["1.2rem", "1.7rem"],
            }}
          />
          <Text
            as="h2"
            sx={{
              fontWeight: "heading",
              fontFamily: "heading",
              fontSize: [3, 4, currentLanguage === "es" ? 6 : 5],
            }}
          >
            {t("home.subTitle")}
          </Text>
        </Flex>
      </Container>
    </motion.div>
  );
};
